<!-- Start layout below the fixed header -->
<div class="flex flex-col">

  <!-- Header -->
  <header>
    <app-header (menuToggle)="toggleSidebar()">
      <img *ngIf="!sidebarOpen" menu-icon src="./assets/images/icons/global/menu.svg" alt="menu">
      <img *ngIf="sidebarOpen" menu-icon src="./assets/images/icons/global/menu-cross.svg" alt="menu-cross">
    </app-header>
  </header>

 <!-- Sidebar -->
  <aside>
    <app-sidebar #sidebar [open]="sidebarOpen" (submenuClosed)="onSubmenuClosed()"></app-sidebar>
  </aside>

  <!-- Main Content -->
  <div class="flex flex-col lg:ms-[58px] pt-[58px] min-h-lvh bg-[#F6F6F6]">

    <!-- Container with border and spacing -->
    <div class="flex flex-col grow lg:ms-0 lg:me-5 lg:mb-5 ms-4 me-4 mb-4 rounded-xl bg-white overflow-hidden border border-gray-300">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

